"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.runWithRetry = runWithRetry;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const error_1 = require("../../error");
const globalVars_1 = require("../../common/globalVars");
async function runWithRetry(run, retryCondition, maxRetry = 3) {
    let lastResult = (0, teamsfx_api_1.err)(new teamsfx_api_1.SystemError("RetryMiddleware", "UninitializedResult", "runWithRetry did not execute the run function."));
    for (let i = 0; i < maxRetry; i++) {
        try {
            lastResult = await run();
            if (!retryCondition(lastResult, i + 1)) {
                return lastResult;
            }
        }
        catch (e) {
            const error = (0, error_1.assembleError)(e);
            if (!retryCondition((0, teamsfx_api_1.err)(error), i + 1)) {
                throw e;
            }
        }
        globalVars_1.TOOLS?.logProvider?.info(`Retrying operation ... (${i + 1}/${maxRetry})`);
    }
    return lastResult;
}
//# sourceMappingURL=retry.js.map